import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const Tab = ({ idPrefix, tabClassName, isActive, onClick, tabIndex, title }) => {
    const tabClasses = classnames(tabClassName, 'btn btn--link nav-tabs__item', {
        'nav-tabs__item--active': isActive,
    });

    return (
        <button
            type="button"
            id={`${idPrefix}-tab-nav-${tabIndex + 1}`}
            className={tabClasses}
            onClick={onClick}
        >
            {title}
        </button>
    );
};

Tab.displayName = 'Tab';

Tab.propTypes = {
    tabClassName: PropTypes.string,
    idPrefix: PropTypes.string,
    isActive: PropTypes.bool,
    onClick: PropTypes.func,
    tabIndex: PropTypes.number,
    title: PropTypes.string,
};

/**
 * Tab Functional Component.
 */
export default Tab;
